/* eslint-disable import/prefer-default-export */
import WithStripes from './components/WithStripes';

const PageHeader = {
    // add default header here
    WithStripes
};

export default PageHeader;
